import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
} from "@angular/forms";
import {
  Buttons_Styles,
  Card_Styles,
  Cards_Types,
  Choices_Styles,
  DropDown_Styles,
  Field_Text_Styles,
  Field_date_time_Styles,
  MENU_BUTTON_FORM,
  c1,
  offcanvasColors,
} from "src/app/core/services/constants";
import { IndexDBService } from "src/app/core/services/indexDB.service";
import { MenuButton } from "src/app/core/services/interface";
import { MiddlwareService } from "src/app/core/services/middleware.service";

@Component({
  selector: "app-row-position-component",
  templateUrl: "./row-position-component.component.html",
  styleUrls: ["./row-position-component.component.scss"],
})
export class RowPositionComponentComponent implements OnInit, OnDestroy {
  constructor(
    private formBuilder: UntypedFormBuilder,
    private mdw: MiddlwareService,
    public indexDBService: IndexDBService,
  ) {}

  @Input() row_id: string;
  @Input() config: any;
  mode: string;

  // default values
  icon: string;
  offCanvasSubscription: any;
  offcanvasColors = offcanvasColors;
  button: MenuButton;
  row: any;
  data: any;
  currentMenuSubscription: any;
  sortedButtonList: any[];
  buttonList: any;
  off_canvas_key: string = "button";
  component_id: string;
  field_id: string;
  isAndroid: boolean;
  text_id: any;
  buttonFormTypes: typeof MENU_BUTTON_FORM = MENU_BUTTON_FORM;
  labelform: UntypedFormGroup;
  @Input() sizeOptions: number[] = [0, 2, 4, 6, 8, 12, 16];

  stylesChoices = [];
  card_types = [];
  sync = true;

  positionOptions = [
    { key: "single", label: "all" },
    { key: "top", label: "top" },
    { key: "middle", label: "middle" },
    { key: "bottom", label: "bottom" },
  ];

  ngOnInit() {
    this.field_id = "label";
    this.labelform = this.formBuilder.group({
      position: new UntypedFormControl("single"),
      vertical: new UntypedFormControl(0),
      horizontal: new UntypedFormControl(0),
    });
    this.offCanvasSubscription = this.mdw.offCanvasContainer$.subscribe(
      (data) => {
        if (
          data &&
          data.off_canvas_key === "row" &&
          data.row &&
          data.row.row_id == this.row_id
        ) {
          this.buttonIntialize(data);
          this.buttonFunction();
        }
      },
    );

    this.currentMenuSubscription = this.mdw.currentMenuContainer$.subscribe(
      (data) => {
        if (
          data &&
          data.off_canvas_key === "row" &&
          data.currentButton &&
          this.row_id &&
          data.currentButton.row_id == this.row_id &&
          data["component_id"] != this.component_id
        ) {
          this.data = data;

          this.sortedButtonList = this.data["sortedButtonList"];
          this.buttonList = this.data["buttonList"];
          this.button = data["buttonList"][this.row_id];
          this.icon;
          this.buttonFunction();
        }
      },
    );
  }

  buttonIntialize(data) {
    this.data = data.data;
    if (data.row.row_id == this.row_id) {
      this.row = { ...data.row };
      this.component_id = this.row.row_id + this.field_id;
    }
    this.sortedButtonList = data.data["sortedButtonList"];
    this.buttonList = this.data["buttonList"];
    this.mode = localStorage.getItem("mode");
  }

  buttonFunction() {
    if (this.row) {
      this.text_id = this.config.id.split(/_(.*)/s)[1];
      this.isAndroid =
        localStorage.getItem("mode")[0] === c1.ANDROID ? true : false;

      this.labelform = this.formBuilder.group({
        position: new UntypedFormControl(
          this.row && this.row.row_position ? this.row.row_position : "single",
        ),
        vertical: new UntypedFormControl(
          this.row &&
            this.row.row_padding &&
            this.row.row_padding.vertical != null
            ? this.row.row_padding.vertical
            : 2,
        ),
        horizontal: new UntypedFormControl(
          this.row &&
            this.row.row_padding &&
            this.row.row_padding.horizontal != null
            ? this.row.row_padding.horizontal
            : 2,
        ),
      });
    }
  }

  selectPosition(key: string) {
  this.labelform.get('position')?.setValue(key);
  this.changePosition();
}

  changePosition() {
    this.row.row_position = this.labelform.value.position;

    this.updateButtonData();
  }
  changeVertical(size) {
    this.labelform.get('vertical')?.setValue(size);
    this.row.row_padding = {
      vertical: this.labelform.value.vertical,
      horizontal: this.labelform.value.horizontal,
    };
    this.updateButtonData();
  }
  changeHorizontal(size) {
    this.labelform.get('horizontal')?.setValue(size);
    this.row.row_padding = {
      vertical: this.labelform.value.vertical,
      horizontal: this.labelform.value.horizontal,
    };
    this.updateButtonData();
  }

  updateButtonData() {
    //*must be there in all buttons
    this.data["rowList"][this.row.row_id] = {
      ...this.data["rowList"][this.row.row_id],
      ...this.row,
    };
    const response = this.indexDBService.updateItem("row", this.row);
    let index = this.sortedButtonList[this.row.row_id].findIndex(
      (e) => e.row_id == this.row_id,
    );
    // this.sortedButtonList[this.button.row_id][index] = { ...this.button };
    // this.data["sortedButtonList"] = this.sortedButtonList;
    // this.data["buttonList"] = this.buttonList;
    this.data["off_canvas_key"] = this.off_canvas_key;
    // this.data["currentButton"] = this.button;
    // console.log(this.data);
    this.mdw._currentMenuContainer.next(this.data);

    this.mdw.changeTab(
      { row: this.row, tab: { module: "menu" } },
      this.mode,
      true,
    );
  }

  ngOnDestroy(): void {
    if (this.offCanvasSubscription) {
      this.offCanvasSubscription.unsubscribe();
    }
    if (this.currentMenuSubscription) {
      this.currentMenuSubscription.unsubscribe();
    }
  }
}
